import classNames from 'classnames';
import React from 'react';

function Cookie({ color = 'currentColor', className = null }) {
    return (
        <svg
            className={classNames(className)}
            width="600px"
            height="600px"
            viewBox="0 0 600 600"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={color}
                d="M300,0C134.3,0,0,134.3,0,300s134.3,300,300,300,300-134.3,300-300-.9-24-2.3-35.8c-10,6.8-22.1,10.8-35.2,10.8-27,0-49.7-17.2-58.5-41-15.6,10-34.1,16-54,16-55.3,0-100-44.7-100-100s5.3-35.4,14-50.2c-.5,0-1,.2-1.5.2-34.6,0-62.5-27.9-62.5-62.5s4.7-26.7,12.4-37c-4.1-.2-8.2-.5-12.4-.5ZM487.5,0c-20.7,0-37.5,16.8-37.5,37.5s16.8,37.5,37.5,37.5,37.5-16.8,37.5-37.5S508.2,0,487.5,0ZM251.3,54.7c5,32.2,23.7,60,49.9,77.1-.8,6-1.2,12.1-1.2,18.2,0,82.7,67.3,150,150,150s24.8-1.6,36.7-4.7c17.1,15.6,38.7,26,62.1,28.9-12.2,126.6-119.1,225.8-248.8,225.8S50,437.9,50,300,136.7,77.4,251.3,54.7ZM450,125c-13.8,0-25,11.2-25,25s11.2,25,25,25,25-11.2,25-25-11.2-25-25-25ZM250,150c-13.8,0-25,11.2-25,25s11.2,25,25,25,25-11.2,25-25-11.2-25-25-25ZM575,150c-13.8,0-25,11.2-25,25s11.2,25,25,25,25-11.2,25-25-11.2-25-25-25ZM175,225c-27.6,0-50,22.4-50,50s22.4,50,50,50,50-22.4,50-50-22.4-50-50-50ZM300,275c-13.8,0-25,11.2-25,25s11.2,25,25,25,25-11.2,25-25-11.2-25-25-25ZM212.5,375c-20.7,0-37.5,16.8-37.5,37.5s16.8,37.5,37.5,37.5,37.5-16.8,37.5-37.5-16.8-37.5-37.5-37.5ZM387.5,400c-20.7,0-37.5,16.8-37.5,37.5s16.8,37.5,37.5,37.5,37.5-16.8,37.5-37.5-16.8-37.5-37.5-37.5Z"
            />
        </svg>
    );
}

export default Cookie;
